export default __webpack_public_path__ + "static/media/Rectangle 5555 (2).c00114d9.png";